import {MissingTranslationHandler, MissingTranslationHandlerParams} from '@ngx-translate/core';
import { Injectable } from "@angular/core";

@Injectable()
export class Ng2MissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams) {
        ////console.error("Missing Translation Key " + params.key);
    }
}
